export var checkSettingsOf = function (periodicalLibrary) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return ({
        titleId: periodicalLibrary.titleId,
        titleName: (_a = periodicalLibrary.title) !== null && _a !== void 0 ? _a : null,
        frequency: periodicalLibrary.frequency,
        continuousNumbering: (_b = periodicalLibrary.continuousNumbering) !== null && _b !== void 0 ? _b : false,
        continuousNumberingAnchorVolumeLabel: (_c = periodicalLibrary.continuousNumberingAnchorVolumeLabel) !== null && _c !== void 0 ? _c : null,
        continuousNumberingStartNumber: (_d = periodicalLibrary.continuousNumberingStartNumber) !== null && _d !== void 0 ? _d : null,
        currentVolumeLabel: (_e = periodicalLibrary.currentVolumeLabel) !== null && _e !== void 0 ? _e : null,
        suggestedContinuousStartNumber: (_f = periodicalLibrary.suggestedContinuousStartNumber) !== null && _f !== void 0 ? _f : null,
        checkPeriodMonths: (_g = periodicalLibrary.checkPeriodMonths) !== null && _g !== void 0 ? _g : null,
        volumeStartDay: (_h = periodicalLibrary.volumeStartDay) !== null && _h !== void 0 ? _h : 1,
        volumeStartMonth: (_j = periodicalLibrary.volumeStartMonth) !== null && _j !== void 0 ? _j : 1,
    });
};
